import React from 'react'
import {
  ReceivementProduct, ReceivementProductFinish, SalesReceivementProduct,
} from 'src/features/receivement/ReceivementTypes'
import { ProductRow } from './ProductRow'
import * as S from './styles'

interface Props {
  product: ReceivementProduct | SalesReceivementProduct | ReceivementProductFinish,
  BatchesTable: React.ElementType,
  ProductRowComponent?: React.ElementType
  headerColor?: string;
}

const ReceivementCard = ({
  product,
  BatchesTable,
  headerColor,
  ProductRowComponent = ProductRow,
}: Props) => {
  if (!product) {
    return <S.SubTitle>Carregando produtos...</S.SubTitle>
  }

  return (
    <ProductRowComponent
      product={product}
      BatchesTable={BatchesTable}
      headerColor={headerColor}
    />
  )
}

export default ReceivementCard
